// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"818":"99e325d3","1400":"2ce279e6","4596":"99e325d3","6868":"83ac2be7","7028":"2ce279e6"}[chunkId] + ".chunk.css";
};